export default __webpack_public_path__ + "static/media/patate.eac5d925.mp3";